import { render, staticRenderFns } from "./TaskMenus.vue?vue&type=template&id=6263904c&scoped=true"
import script from "./TaskMenus.vue?vue&type=script&lang=js"
export * from "./TaskMenus.vue?vue&type=script&lang=js"
import style0 from "./TaskMenus.vue?vue&type=style&index=0&id=6263904c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6263904c",
  null
  
)

export default component.exports